module.exports = __webpack_public_path__ + "static/media/play-again.bd1faa31.jpg";